import api from './api';

const statutsLitigesApi = {
  // Récupérer tous les statuts
  getAll: () => {
    return api.get('/statuts-litiges');
  },

  // Créer un statut
  create: (data) => {
    return api.post('/statuts-litiges', data);
  },

  // Modifier un statut
  update: (id, data) => {
    return api.put(`/statuts-litiges/${id}`, data);
  },

  // Supprimer un statut
  delete: (id) => {
    return api.delete(`/statuts-litiges/${id}`);
  }
};

export default statutsLitigesApi;
